import React from "react";
import SbEditable from "storyblok-react";
import ContactForm from "./Forms/ContactForm";
import FluidImage from "src/utils/FluidImage";


const SplitWithImageContact = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div id="contact-us" className={`relative bg-white`}>
        <div className="max-w-7xl mx-auto px-6 lg:py-24 py-12 flex lg:flex-row flex-col items-center gap-16">
          <div className={`relative max-w-lg w-full`}>
            <ContactForm title={blok.title} supporting_text={blok.supporting_text}/>
          </div>
          <div className={`flex-1 w-full`}>
            <div className="relative">
              <FluidImage
                image={blok?.image}
                className="w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default SplitWithImageContact;
